// src/pages/Admin/SystemStatsPage.tsx
import { Container, Grid, Typography } from '@mui/material';
import KpiStatsCards from '../../components/Dashboard/KpiStatsCards';
import ProjectStatusSummary from '../../components/Dashboard/ProjectStatusSummary';

export function SystemStatsPage() {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h4" component="h1" sx={{ color: 'white', mb: 3 }}>
        System Stats
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Operational metrics and project status across all airports.
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <KpiStatsCards type="system" />
        </Grid>
        <Grid item xs={12} md={6}>
          <ProjectStatusSummary airportId={undefined} />
        </Grid>
      </Grid>
    </Container>
  );
}
